import gql from 'graphql-tag';

export const GET_LOGGEDIN_USER_QUERY = gql`
  query bootstrap {
    bootstrap {
      username
      firstName
      lastName
      email
      appRole
      accountId
      customerId
    }
    settings {
      enableMove
      enableAirportTransfer
      enableShortStay
      enableTicket
      enableSettlingIn
      enableHousing
      enableBudget
    }
  }
`;
